
<template>
  <div :class="classes" :disabled="disableStatus" @mouseover="_addFocusClass" @mouseout="_removeFocusClass">
    <div :class="prefix+'-handler-wrap'">
      <span
        :disabled="disabled_plus"
        :class="[disabled_plus ? 'btn-secondary' : '', prefix+'__control']"
        @click="_plus"
      >
        <t-icon icon="arrow-up-drop-outline"></t-icon>
      </span>
      <span
        :disabled="disabled_minus"
        :class="[disabled_minus ? 'btn-secondary' : '', prefix+'__control']"
        @click="_minus"
      >
        <t-icon icon="arrow-down-drop-outline"></t-icon>
      </span>
    </div>
    <input
      v-model="currentVal"
      type="text"
      :class="inputClass"
      :disabled="disableStatus"
      @blur="_blur"
    >
  </div>
</template>
<script>
import { PREFIX_CLASS } from '@/utils/constants'
const INPUT_NUMBER_PREFIX_CLASS = `${PREFIX_CLASS}form-input-number`
const maxNum = 10000000000000000000
function changeNum(num, step) {
  let numDecimalDigits, stepDecimalDigits, m
  try {
    numDecimalDigits = num.toString().split('.')[1].length
  } catch (e) {
    numDecimalDigits = 0
  }
  try {
    stepDecimalDigits = step.toString().split('.')[1].length
  } catch (e) {
    stepDecimalDigits = 0
  }
  m = Math.pow(10, Math.max(numDecimalDigits, stepDecimalDigits))
  return (Math.round(num * m) + Math.round(step * m)) / m
}

export default {
  name: 'TNumberstepper',
  props: {
    // 初始默认值
    value: {
      type: Number,
      default: 0
    },
    // 初始默认值
    current: {
      type: Number,
      default: 0
    },
    // 最大值
    max: {
      type: Number,
      default: Infinity
    },
    // 最小值
    min: {
      type: Number,
      default: -Infinity
    },
    // 步数值
    step: {
      type: Number,
      default: 1,
      validator: value => value >= 0
    },
    // 是否禁止点击
    disabled: {
      type: Boolean,
      default: false
    },
    // 组件的大小=>''、sm、lg
    size: {
      type: String,
      default: '',
      validator(value) {
        return ['', 'sm', 'lg'].indexOf(value) > -1
      }
    }
  },
  data() {
    return {
      prefix: INPUT_NUMBER_PREFIX_CLASS,
      currentVal: this.value || this.current,
      disabled_minus: false,
      disabled_plus: false,
      disableStatus: this.disabled,
      focusClass: false
    }
  },
  computed: {
    inputClass() {
      return [
        `${PREFIX_CLASS}input`,
        `${INPUT_NUMBER_PREFIX_CLASS}__input`
      ]
    },
    // size的值为''、sm、lg时所对应的样式不同
    classes() {
      return [
        this.prefix,
        this.size ? `${this.prefix}--${this.size}` : '',
        this.focusClass ? `${this.prefix}-focus` : '',
        this.disableStatus ? 'disabled' : ''
      ]
    }
  },
  watch: {
    value(newVal) {
      this.currentVal = newVal
    },
    currentVal(newVal, oldVal) {
      if (isNaN(newVal)) {
        this.currentVal = oldVal
      }
      this._checkStatus(newVal)
    }
  },
  created() {
    this._checkValid()
    this._checkStatus(this.currentVal)
  },
  methods: {
    _addFocusClass() {
      if (this.disabled) return
      this.focusClass = true
    },
    _removeFocusClass() {
      if (this.disabled) return
      this.focusClass = false
    },
    // 当输入框失去焦点的时候触发
    _blur(e) {
      let inputVal = Number(e.target.value)
      if (isNaN(inputVal)) {
        inputVal = this.value
      }
      this._setValue(inputVal)
    },
    _checkValid(val) {
      this.disableStatus = this.disabled || (val < this.min || val > this.max)
    },
    _checkStatus(val) {
      this.disabled_minus = false
      this.disabled_plus = false
      if (val <= this.min) {
        this.disabled_minus = true
      } else if (val >= this.max) {
        this.disabled_plus = true
      }
    },
    toggle(value) {
      this.disableStatus = !this.disableStatus
    },
    _setValue(nextValue) {
      let oldValue = this.currentVal
      nextValue = Number.parseFloat(nextValue)
      if (nextValue < this.min) {
        this.currentVal = this.min
      } else if (nextValue > this.max) {
        this.currentVal = this.max
      } else if (nextValue > maxNum) {
        this.currentVal = maxNum
      } else if (nextValue < -maxNum) {
        this.currentVal = -maxNum
      } else {
        this.currentVal = nextValue
      }
      this.$emit('input', this.currentVal)
      this.$emit('on-change', this.currentVal, oldValue)
    },
    _plus() {
      if (this.disabled) return
      this._setValue(changeNum(this.currentVal, this.step))
    },
    _minus() {
      if (this.disabled) return
      this._setValue(changeNum(this.currentVal, -this.step))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/number-stepper/number-stepper.vue